import { useEffect, useRef } from 'react';
import { useSnackbar } from '@planitgeo/treeplotter-ui-library';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useLocales } from 'locales';
import {
  setNavigateToHome,
  setTriggerTenantSelection,
  TENANT_SWITCH_NOTIFICATION_COOLDOWN_MS,
} from 'identityAndAccess/infrastructure/jwtClaimVerification';
import { showTenantSelection } from 'identityAndAccess/infrastructure/auth/redux';
import TenantRepository from 'common/infrastructure/tenant/repository';

export default function TenantSwitchNotification() {
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { translate } = useLocales();

  // Subscribe to current tenant from Redux
  const currentTenantId = TenantRepository.getCurrentTenantPid();

  const previousTenantIdRef = useRef<string | null>(null);
  const lastNotificationTimeRef = useRef<number>(0);

  // Watch for tenant changes and show snackbar
  useEffect(() => {
    const previousTenantId = previousTenantIdRef.current;

    // Show notification if tenant actually changed (both must be truthy to be a real change)
    if (previousTenantId && currentTenantId && previousTenantId !== currentTenantId) {
      const now = Date.now();

      if (now - lastNotificationTimeRef.current >= TENANT_SWITCH_NOTIFICATION_COOLDOWN_MS) {
        enqueueSnackbar(translate('tenant_switched_simple'), {
          variant: 'info',
          autoHideDuration: 8000,
          preventDuplicate: true,
        });

        lastNotificationTimeRef.current = now;
      }
    }

    // Update the previous tenant reference for next comparison
    previousTenantIdRef.current = currentTenantId;
  }, [currentTenantId, enqueueSnackbar, translate]);

  useEffect(() => {
    setNavigateToHome(() => {
      navigate('/');
    });

    setTriggerTenantSelection(() => {
      dispatch(showTenantSelection());
    });

    return () => {
      setNavigateToHome(() => {});
      setTriggerTenantSelection(() => {});
    };
  }, [navigate, dispatch]);

  return null;
}
